import {
  LOCALIZACION_LIMPIEZA_PISTA,
  ACTUACION_LIMPIEZA_PISTA,
  SENTIDOS,
  TRAZAS,
  UNIDADES
} from './selectOptions'
import TYPES from '../../../../core/assets/assetTypes'
import comunIdentificacionFormFields from './comunIdentificacionFormFields'
import comunValidacionFormFields from './comunValidacionFormFields'

export const identificacion = (workOrderFragment, familyFragment) => [
  ...comunIdentificacionFormFields(
    workOrderFragment,
    'limpiezasPista',
    familyFragment,
    [TYPES.FIRMES]
  ),

  {
    label: 'Localización',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'limpiezasPista',
      familyFragment,
      'identificacion',
      'localizacion'
    ],
    meta: {
      options: LOCALIZACION_LIMPIEZA_PISTA
    }
  },

  {
    label: 'Comentarios',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'limpiezasPista',
      familyFragment,
      'identificacion',
      'comentarios'
    ]
  }
]

export const inspeccion = (workOrderFragment, familyFragment) => [
  {
    label: 'PK Inicio',
    type: 'PK',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'limpiezasPista',
      familyFragment,
      'inspeccion',
      'pkInicio'
    ]
  },

  {
    label: 'PK Fin',
    type: 'PK',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'limpiezasPista',
      familyFragment,
      'inspeccion',
      'pkFin'
    ]
  },

  {
    label: 'Trabajos programados',
    type: 'Checkbox',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'limpiezasPista',
      familyFragment,
      'inspeccion',
      'trabajosProgramados'
    ]
  },

  {
    label: 'Observaciones',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'limpiezasPista',
      familyFragment,
      'inspeccion',
      'observaciones'
    ]
  },

  {
    label: 'Fotos antes',
    type: 'Documents',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'limpiezasPista',
      familyFragment,
      'inspeccion',
      'antesFotos'
    ],
    meta: { isPhotos: true }
  }
]

export const ejecucion = (workOrderFragment, familyFragment) => [
  {
    label: 'Actuación',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'limpiezasPista',
      familyFragment,
      'ejecucion',
      'actuacion'
    ],
    meta: {
      options: ACTUACION_LIMPIEZA_PISTA
    }
  },

  {
    label: 'PK Inicio',
    type: 'PK',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'limpiezasPista',
      familyFragment,
      'ejecucion',
      'pkInicio'
    ]
  },

  {
    label: 'PK Fin',
    type: 'PK',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'limpiezasPista',
      familyFragment,
      'ejecucion',
      'pkFin'
    ]
  },

  {
    label: 'Coordenadas PK Inicio',
    type: 'Coordinates',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'limpiezasPista',
      familyFragment,
      'ejecucion',
      'coordenadasPkInicio'
    ]
  },

  {
    label: 'Coordenadas PK Fin',
    type: 'Coordinates',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'limpiezasPista',
      familyFragment,
      'ejecucion',
      'coordenadasPkFin'
    ]
  },

  {
    label: 'Sentido',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'limpiezasPista',
      familyFragment,
      'ejecucion',
      'sentido'
    ],
    meta: {
      options: SENTIDOS
    }
  },

  {
    label: 'Traza',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'limpiezasPista',
      familyFragment,
      'ejecucion',
      'traza'
    ],
    meta: {
      options: TRAZAS
    }
  },

  {
    label: 'Medición',
    type: 'Number',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'limpiezasPista',
      familyFragment,
      'ejecucion',
      'medicion'
    ]
  },

  {
    label: 'Unidad',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'limpiezasPista',
      familyFragment,
      'ejecucion',
      'unidad'
    ],
    meta: {
      options: UNIDADES
    }
  },

  {
    label: 'Trabajos programados',
    type: 'Checkbox',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'limpiezasPista',
      familyFragment,
      'ejecucion',
      'trabajosProgramados'
    ]
  },

  {
    label: 'Observaciones',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'limpiezasPista',
      familyFragment,
      'ejecucion',
      'observaciones'
    ]
  },

  {
    label: 'Fotos despues',
    type: 'Documents',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'limpiezasPista',
      familyFragment,
      'ejecucion',
      'despuesFotos'
    ],
    meta: { isPhotos: true }
  }
]

export const validacion = comunValidacionFormFields('limpiezasPista')
